export default __webpack_public_path__ + "static/media/search.638b0849.svg";